import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "ID", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }

import { ref, onMounted, computed } from "vue";
import ToolServices from "../services/ToolServices";
import TableFooter from "@/components/TableFooter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFaCodeIndex',
  setup(__props) {

const isLoading = ref(false);
const detail = ref(Array<any>());
const criteria = ref<any>({
  page: 1,
  size: 25,
});
const currentTime = computed(() => new Date().toISOString());
const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const data = await ToolServices.getTwoFaCode(criteria.value);
    criteria.value = data.criteria;
    detail.value = data.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const reset = () => {
  criteria.value = {
    page: 1,
    size: 25,
  };
  fetchData(1);
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_TimeShow = _resolveComponent("TimeShow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: criteria.value.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.email) = $event)),
          class: "w-300px",
          placeholder: "Email",
          disabled: isLoading.value,
          clearable: ""
        }, null, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_input, {
          modelValue: criteria.value.code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.code) = $event)),
          class: "ms-3 w-100px",
          placeholder: "Code",
          disabled: isLoading.value,
          clearable: ""
        }, null, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_input, {
          modelValue: criteria.value.partyId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria.value.partyId) = $event)),
          class: "ms-3 w-100px",
          placeholder: "Party ID",
          disabled: isLoading.value,
          clearable: ""
        }, null, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_button, {
          type: "warning",
          disabled: isLoading.value,
          class: "ms-3",
          plain: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (fetchData(1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          disabled: isLoading.value,
          onClick: reset
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.code")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.event")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.expireDate")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && detail.value?.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, [
                      (item.status == 1)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("status.used")), 1)
                            ]),
                            _: 1
                          }))
                        : (item.expireOn < currentTime.value)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 1,
                              type: "info"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("fields.expired")), 1)
                              ]),
                              _: 1
                            }))
                          : (item.status == 0)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 2,
                                type: "success"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("fields.valid")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.code), 1),
                    _createElementVNode("td", null, _toDisplayString(item.event), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_UserInfo, {
                        user: item.user,
                        class: "me-2"
                      }, null, 8, ["user"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        "date-iso-string": item.createdOn,
                        type: "GMToneLiner"
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        "date-iso-string": item.expireOn,
                        type: "GMToneLiner"
                      }, null, 8, ["date-iso-string"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ])
  ]))
}
}

})